import React from 'react';
import styled from 'styled-components';

interface RevisementProps {
  EditorSection: React.FC;
  BottomBar: React.FC;
}
const FlexDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
`;

const Revisement: React.FC<RevisementProps> = ({
  EditorSection,
  BottomBar,
}) => {
  return (
    <FlexDiv>
      <EditorSection />
      <BottomBar />
    </FlexDiv>
  );
};

export default Revisement;
